function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/** UI-only: scaffold unlock fields (witness) on the authoritative script object. */

var PLACEHOLDER_PATTERN = /^<([^<>]+)>$/;
function resolveOpcodeDefinition(opcodes, opName) {
  var handler = opcodes === null || opcodes === void 0 ? void 0 : opcodes[String(opName || '').toLowerCase()];
  if (!handler) {
    return null;
  }
  if (handler.opcode && _typeof(handler.opcode) === 'object') {
    return handler.opcode;
  }
  if (handler.name || handler.exampleScript) {
    return handler;
  }
  return null;
}
function lockingView(node) {
  if (!node || _typeof(node) !== 'object') {
    return node;
  }
  if (Array.isArray(node)) {
    return node.map(lockingView);
  }
  var out = {};
  for (var _i = 0, _Object$keys = Object.keys(node); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (key === 'witness') {
      continue;
    }
    out[key] = lockingView(node[key]);
  }
  return out;
}
var PLACEHOLDER_META = {
  signature: {
    label: 'Signature',
    hint: 'Required signature for this condition',
    action: 'signature'
  },
  signatures: {
    label: 'Signatures',
    hint: 'Required signatures (M-of-N)',
    action: 'text'
  },
  publickey: {
    label: 'Public key',
    hint: 'Saito public key for this contract field',
    action: 'publickey'
  },
  hash: {
    label: 'Hash',
    hint: 'Expected hash digest (Blake3)',
    action: 'hash'
  },
  msg: {
    label: 'Message',
    hint: 'Message that was signed',
    action: 'text'
  },
  text: {
    label: 'Text',
    hint: 'Text value for this field',
    action: 'text'
  },
  input: {
    label: 'Input',
    hint: 'Required preimage to hash',
    action: 'text'
  }
};
function isPlaceholder(value) {
  return typeof value === 'string' && PLACEHOLDER_PATTERN.test(value.trim());
}
function placeholderName(value) {
  var match = String(value).trim().match(PLACEHOLDER_PATTERN);
  return match ? match[1].toLowerCase() : null;
}
function placeholderMeta(value) {
  var name = placeholderName(value);
  if (!name) {
    return null;
  }
  return PLACEHOLDER_META[name] || {
    label: name,
    hint: "Provide value for <".concat(name, ">"),
    action: 'text'
  };
}
function isWitnessPath(path) {
  if (!Array.isArray(path) || path.length < 2) {
    return false;
  }
  var witnessIndex = path.indexOf('witness');
  return witnessIndex >= 0 && witnessIndex < path.length - 1;
}
function isWitnessValueSupplied(value) {
  if (value === true || value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'string' && (value.trim() === '' || isPlaceholder(value))) {
    return false;
  }
  return true;
}
function unlockFieldNames(opcodes, opName) {
  var _resolveOpcodeDefinit;
  var witness = (_resolveOpcodeDefinit = resolveOpcodeDefinition(opcodes, opName)) === null || _resolveOpcodeDefinit === void 0 || (_resolveOpcodeDefinit = _resolveOpcodeDefinit.exampleScript) === null || _resolveOpcodeDefinit === void 0 ? void 0 : _resolveOpcodeDefinit.witness;
  if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
    return [];
  }
  return Object.keys(witness);
}
function isWitnessFieldEmbedded(node, fieldKey) {
  var required = node !== null && node !== void 0 && node.required && _typeof(node.required) === 'object' ? node.required : {};
  if (isWitnessValueSupplied(required[fieldKey])) {
    return true;
  }
  var reference = node !== null && node !== void 0 && node.reference && _typeof(node.reference) === 'object' ? node.reference : {};
  return isWitnessValueSupplied(reference[fieldKey]);
}

/** Unlock fields still needed at test time (not embedded in locking required/reference). */
function unlockWitnessFieldNames(opcodes, opName, node) {
  return unlockFieldNames(opcodes, opName).filter(function (key) {
    return !isWitnessFieldEmbedded(node, key);
  });
}
function cloneScriptTree(node) {
  if (!node || _typeof(node) !== 'object') {
    return node;
  }
  var op = String(node.op || '').toLowerCase();
  if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
    var children = Array.isArray(node.args) ? node.args : [];
    return {
      op: node.op,
      args: children.map(function (child) {
        return cloneScriptTree(child);
      })
    };
  }
  var out = JSON.parse(JSON.stringify(node));
  delete out.witness;
  return out;
}
function preserve_witness_in_tree(previous, next, opcodes) {
  if (!next || _typeof(next) !== 'object') {
    return next;
  }
  if (!previous || _typeof(previous) !== 'object') {
    return apply_witness_scaffold_tree(next, opcodes);
  }
  var op = String(next.op || '').toLowerCase();
  if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
    var prevArgs = Array.isArray(previous.args) ? previous.args : [];
    var nextArgs = Array.isArray(next.args) ? next.args : [];
    return apply_witness_scaffold_tree(_objectSpread(_objectSpread({}, next), {}, {
      args: nextArgs.map(function (child, i) {
        return preserve_witness_in_tree(prevArgs[i], child, opcodes);
      })
    }), opcodes);
  }
  var merged = JSON.parse(JSON.stringify(next));
  var prevWitness = previous.witness && _typeof(previous.witness) === 'object' ? previous.witness : {};
  var mergedWitness = {};
  for (var _i2 = 0, _Object$keys2 = Object.keys(prevWitness); _i2 < _Object$keys2.length; _i2++) {
    var key = _Object$keys2[_i2];
    if (isWitnessFieldEmbedded(merged, key)) {
      continue;
    }
    var val = prevWitness[key];
    mergedWitness[key] = val !== null && _typeof(val) === 'object' ? JSON.parse(JSON.stringify(val)) : val;
  }
  if (Object.keys(mergedWitness).length > 0) {
    merged.witness = mergedWitness;
  } else {
    delete merged.witness;
  }
  if (merged.required && _typeof(merged.required) === 'object' && Object.keys(merged.required).length === 0) {
    delete merged.required;
  }
  return apply_witness_scaffold_tree(merged, opcodes);
}
function witnessPlaceholder(opcodes, opName, fieldKey) {
  var _resolveOpcodeDefinit2;
  var example = (_resolveOpcodeDefinit2 = resolveOpcodeDefinition(opcodes, opName)) === null || _resolveOpcodeDefinit2 === void 0 || (_resolveOpcodeDefinit2 = _resolveOpcodeDefinit2.exampleScript) === null || _resolveOpcodeDefinit2 === void 0 || (_resolveOpcodeDefinit2 = _resolveOpcodeDefinit2.witness) === null || _resolveOpcodeDefinit2 === void 0 ? void 0 : _resolveOpcodeDefinit2[fieldKey];
  if (typeof example === 'string') {
    return example;
  }
  if (Array.isArray(example)) {
    return cloneScript(example);
  }
  if (example !== undefined && example !== null && _typeof(example) !== 'object') {
    return example;
  }
  return "<".concat(fieldKey, ">");
}
function apply_witness_scaffold_tree(node, opcodes) {
  if (!node || _typeof(node) !== 'object') {
    return node;
  }
  var op = String(node.op || '').toLowerCase();
  if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
    var children = Array.isArray(node.args) ? node.args : [];
    return _objectSpread(_objectSpread({}, node), {}, {
      args: children.map(function (child) {
        return apply_witness_scaffold_tree(child, opcodes);
      })
    });
  }
  var fields = unlockWitnessFieldNames(opcodes, op, node);
  if (!fields.length) {
    return node;
  }
  var out = JSON.parse(JSON.stringify(node));
  if (!out.witness || _typeof(out.witness) !== 'object' || Array.isArray(out.witness)) {
    out.witness = {};
  }
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (out.witness[key] === undefined) {
        out.witness[key] = witnessPlaceholder(opcodes, op, key);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (Object.keys(out.witness).length === 0) {
    delete out.witness;
  }
  return out;
}
function build_test_script_from_create(createScript, currentTest, opcodes) {
  var fresh = cloneScriptTree(createScript);
  return preserve_witness_in_tree(currentTest, fresh, opcodes);
}
function collectWitnessMissing(node, opcodes) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var found = [];
  function walk(n, p) {
    if (!n || _typeof(n) !== 'object') {
      return;
    }
    var op = String(n.op || '').toLowerCase();
    if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
      var children = Array.isArray(n.args) ? n.args : [];
      for (var i = 0; i < children.length; i++) {
        walk(children[i], p.concat("args[".concat(i, "]")));
      }
      return;
    }
    var witness = n.witness && _typeof(n.witness) === 'object' ? n.witness : {};
    var _iterator2 = _createForOfIteratorHelper(unlockWitnessFieldNames(opcodes, op, n)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        if (!isWitnessValueSupplied(witness[key])) {
          found.push([].concat(_toConsumableArray(p), ['witness', key]).join('.'));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  walk(node, path);
  return found;
}
function opcodeTreeNeedsWitness(node, opcodes) {
  var found = false;
  function walk(n) {
    if (!n || _typeof(n) !== 'object' || found) {
      return;
    }
    var op = String(n.op || '').toLowerCase();
    if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
      (n.args || []).forEach(walk);
      return;
    }
    if (unlockFieldNames(opcodes, op).length > 0) {
      found = true;
    }
  }
  walk(node);
  return found;
}
function cloneScript(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Locking-half template from an opcode definition (no witness / required).
 * Used only to fill keys that are absent on an instance — never for display clones.
 */
function lockingTemplateFromOpcode(opcodes, opName) {
  var opDef = resolveOpcodeDefinition(opcodes, opName);
  if (!(opDef !== null && opDef !== void 0 && opDef.exampleScript) || _typeof(opDef.exampleScript) !== 'object') {
    return null;
  }
  var script = cloneScript(opDef.exampleScript);
  delete script.witness;
  delete script.required;
  return script;
}

/**
 * Expand a parsed/partial AST into the canonical locking instance:
 * absent locking keys are filled from the opcode locking template.
 * Never adds witness. Never overwrites keys already present on the node.
 */
function expandLockingTree(node, opcodes) {
  if (!node || _typeof(node) !== 'object' || Array.isArray(node)) {
    return node;
  }
  var op = String(node.op || '').toLowerCase();
  if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
    var children = Array.isArray(node.args) ? node.args : [];
    return {
      op: node.op,
      args: children.map(function (child) {
        return expandLockingTree(child, opcodes);
      })
    };
  }
  var template = lockingTemplateFromOpcode(opcodes, node.op);
  if (!template) {
    var passthrough = cloneScript(node);
    delete passthrough.witness;
    return passthrough;
  }
  var out = {};
  out.op = node.op !== undefined ? node.op : template.op;
  for (var _i3 = 0, _Object$keys3 = Object.keys(template); _i3 < _Object$keys3.length; _i3++) {
    var key = _Object$keys3[_i3];
    if (key === 'op') {
      continue;
    }
    if (Object.prototype.hasOwnProperty.call(node, key)) {
      var val = node[key];
      out[key] = val !== null && _typeof(val) === 'object' ? expandLockingTreeDeepValue(val, opcodes) : val;
    } else {
      out[key] = cloneScript(template[key]);
    }
  }
  for (var _i4 = 0, _Object$keys4 = Object.keys(node); _i4 < _Object$keys4.length; _i4++) {
    var _key = _Object$keys4[_i4];
    if (_key === 'op' || _key === 'witness' || _key === 'required') {
      continue;
    }
    if (!Object.prototype.hasOwnProperty.call(out, _key)) {
      var _val = node[_key];
      out[_key] = _val !== null && _typeof(_val) === 'object' ? expandLockingTreeDeepValue(_val, opcodes) : _val;
    }
  }
  return out;
}
function expandLockingTreeDeepValue(value, opcodes) {
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return item !== null && _typeof(item) === 'object' && !Array.isArray(item) && item.op ? expandLockingTree(item, opcodes) : item !== null && _typeof(item) === 'object' ? cloneScript(item) : item;
    });
  }
  if (value && _typeof(value) === 'object' && value.op) {
    return expandLockingTree(value, opcodes);
  }
  return cloneScript(value);
}
function lockingFromOpcode(opcodes, key) {
  var opDef = resolveOpcodeDefinition(opcodes, key);
  if (!(opDef !== null && opDef !== void 0 && opDef.exampleScript)) {
    return {
      op: String(key || '').toUpperCase()
    };
  }
  return expandLockingTree({
    op: opDef.name || String(key || '').toUpperCase()
  }, opcodes);
}
function getContractTemplates(opcodes) {
  var multisig = lockingFromOpcode(opcodes, 'checkmultisig');
  var multiApproval = cloneScript(multisig);
  if (multiApproval.m !== undefined) {
    multiApproval.m = 3;
  }
  return [{
    id: 'shared-wallet',
    name: 'Shared Wallet',
    description: 'Several people must agree before anything moves.',
    locking: multisig
  }, {
    id: 'secret-vault',
    name: 'Secret Vault',
    description: 'Unlock only when the correct secret is revealed.',
    locking: lockingFromOpcode(opcodes, 'checkhash')
  }, {
    id: 'timed-release',
    name: 'Timed Release',
    description: 'Funds unlock only after a chosen moment in time.',
    locking: lockingFromOpcode(opcodes, 'checktime')
  }, {
    id: 'challenge',
    name: 'Challenge Contract',
    description: 'Prove you signed a specific challenge message.',
    locking: function () {
      var s = lockingFromOpcode(opcodes, 'checksig');
      s.msg = 'challenge: prove you control this rule';
      return s;
    }()
  }, {
    id: 'tournament-prize',
    name: 'Tournament Prize',
    description: 'Reward must pay a specific winner address.',
    locking: lockingFromOpcode(opcodes, 'checkrecipient')
  }, {
    id: 'multi-approval',
    name: 'Multi-user Approval',
    description: 'A committee must reach a higher approval threshold.',
    locking: multiApproval
  }];
}
module.exports = {
  isPlaceholder: isPlaceholder,
  placeholderName: placeholderName,
  placeholderMeta: placeholderMeta,
  isWitnessPath: isWitnessPath,
  isWitnessValueSupplied: isWitnessValueSupplied,
  resolveOpcodeDefinition: resolveOpcodeDefinition,
  lockingView: lockingView,
  unlockFieldNames: unlockFieldNames,
  unlockWitnessFieldNames: unlockWitnessFieldNames,
  cloneScriptTree: cloneScriptTree,
  preserve_witness_in_tree: preserve_witness_in_tree,
  build_test_script_from_create: build_test_script_from_create,
  collectWitnessMissing: collectWitnessMissing,
  opcodeTreeNeedsWitness: opcodeTreeNeedsWitness,
  lockingTemplateFromOpcode: lockingTemplateFromOpcode,
  expandLockingTree: expandLockingTree,
  lockingFromOpcode: lockingFromOpcode,
  getContractTemplates: getContractTemplates
};